import { render, staticRenderFns } from "./ContactsCRM.vue?vue&type=template&id=1dbc1222&scoped=true"
import script from "./ContactsCRM.vue?vue&type=script&lang=js"
export * from "./ContactsCRM.vue?vue&type=script&lang=js"
import style0 from "./contacts-crm.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./ContactsCRM.vue?vue&type=style&index=1&id=1dbc1222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbc1222",
  null
  
)

export default component.exports